import { render } from "./Settings.vue?vue&type=template&id=77176fdc&ts=true"
import script from "./Settings.vue?vue&type=script&lang=ts"
export * from "./Settings.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"client/components/Windows/Settings.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "77176fdc"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('77176fdc', __exports__)) {
    api.reload('77176fdc', __exports__)
  }
  
  module.hot.accept("./Settings.vue?vue&type=template&id=77176fdc&ts=true", () => {
    api.rerender('77176fdc', render)
  })

}


export default __exports__